import { request } from "utils/request";
import { AxiosPromise } from "axios";
import { CommentFile, CommentRefType } from "types/comment";

export const commentApi = {
  findAll: (params: {
    page: number;
    limit: number;
    refType: CommentRefType;
    refId: number;
  }): AxiosPromise<any> =>
    request({
      url: "/v1/admin/comment",
      params,
    }),
  create: (data: {
    comment: {
      content: string;
      refType: CommentRefType;
      refId: number;
      files: CommentFile[];
    };
    parentId?: number;
    mentionStaffIds?: number[];
  }): AxiosPromise<any> =>
    request({
      url: "/v1/admin/comment",
      data,
      method: "post",
    }),
  delete: (id: number): AxiosPromise<any> =>
    request({
      url: `/v1/admin/comment/${id}`,
      method: "delete",
    }),
};
